import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/observable/of';

@Injectable()
export class LehtikoneApiService {
  readonly LEHTIKONE_API_URL = 'http://46.22.221.22:3001/api/v1';
  private header: Headers = new Headers();

  constructor( private http: Http ) {
    this.generateHeaders();
  }

  getData(publication_id: any) {
    return this.generateHeaders()
      .mergeMap( header => {
        return Observable.forkJoin(
          this.http
            .get(
              this.LEHTIKONE_API_URL + '/publications/' + publication_id,
              {
                headers: header
              }
            )
            .map( response => response.json() ),
          this.http
            .get(
              this.LEHTIKONE_API_URL + '/publications/' + publication_id + '/articles',
              {
                headers: header
              }
            )
            .map( response => response.json() )
            .mergeMap( articles => {
              return Observable.of(
                articles.map( article => {
                  return Object.assign( article, {
                      img: ((): any => {
                        let img = {};
                        this.http
                          .get(
                            this.LEHTIKONE_API_URL + '/users/1/articles/' + article.id + '/images',
                            {
                              headers: header
                            }
                          )
                          .map( images => {
                            let i = images.json();
                            return i && i.length && i[ 0 ] || null;
                          } )
                          .subscribe(
                            image => {
                              Object.assign( img, image );
                            }
                          );
                        return img;
                      })()
                  } );
                })
              );
            }),
          this.http
            .get(
              this.LEHTIKONE_API_URL + '/publications/' + publication_id + '/users',
              {
                headers: header
              }
            )
            .map(users => users.json()),
          this.http
            .get(
              this.LEHTIKONE_API_URL + '/publications/' + publication_id + '/covers',
              {
                headers: header
              }
            )
            .map(covers => covers.json())
            .mergeMap( cover => {
              return Observable.of(cover);
            })
            /*
            .flatMap( data => {
              return Observable.forkJoin(
                Observable.of(data),
                Observable.forkJoin(
                  Array.from(new Set(data.map( article => article.user_id)))
                  .map( user_id  => {
                    return this.http
                      .get(
                        this.LEHTIKONE_API_URL + '/users/' + user_id,
                        {
                          headers: header
                        }
                      )
                      .map(user => user.json());
                  })
                )
              );
            })*/
        );

      });
  }

  getArticle(id: number) {
    return this.generateHeaders()
      .flatMap( header => {
        return this.http
          .get(
            this.LEHTIKONE_API_URL + '/publications/' + 1 + '/articles/' + id,
            {
              headers: header
            }
          )
          .map( response => response.json() );
      });
  }

  private generateHeaders() {
    return Observable.create( subscriber => {
      if (!this.header) {
        subscriber.next(this.header);
      } else {
        this.http.post( this.LEHTIKONE_API_URL + '/auth/sign_in', {
        'email': 'joni@kairo.fi',
        'password': '12345678'
      } ).subscribe(
        resp => {
          console.log( resp && resp.json().data );
          let header = {};
          resp.headers.forEach( ( value: string[], key: string ) => {
            switch ( key.toLowerCase() ) {
              case 'access-token':
              case 'client':
              case 'expiry':
              case 'uid':
              case 'token-type':
                header[ key ] = value;
            }
          } );
          this.header = new Headers( header );
          subscriber.next(this.header);
        },
        error => {
        },
        () => {
          subscriber.complete();
        }
      );
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/lehtikone-api.service.ts